import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import useMediaQuery from '@mui/material/useMediaQuery';

import { formatChipTagList } from './helpers';

const VpMediaTagsList = ({ tags = [] }) => {
  const isSmallDesktop = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const [tagList, hiddenTags] = useMemo(() => formatChipTagList(tags, isSmallDesktop), [tags]);
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {tagList?.map((tag) => {
        const isExcessCountChip = tag?.id === 'extra-count';

        return isExcessCountChip ? (
          <Tooltip title={hiddenTags?.map((tag) => ` ${tag.name}`).toString()}>
            <Chip label={tag?.name} key={tag?.id} />
          </Tooltip>
        ) : (
          <Chip label={tag?.name} key={tag?.id} />
        );
      })}
    </Stack>
  );
};

VpMediaTagsList.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string
    })
  ).isRequired
};

export default VpMediaTagsList;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/VpMediaTagsList.jsx